import { TestConfigData } from '../../test-configurator-provider';
import { TestConfigStepType, TestConfiguratorStepsData } from '../test-config-steps-provider.interfaces';

export const getConfigStepsDataToMatchCompletedSteps = (configData: TestConfigData): TestConfiguratorStepsData | {} => {
  const steps = [];
  const { opposition, examType, hasChallenge, examTemplate, numOfQuestions, contentIds, contentLabel } = configData;

  if (opposition) {
    steps.push({ stepType: TestConfigStepType.SET_OPPOSITION, isCompleted: true });
  }

  if (hasChallenge && !examType) {
    steps.push({ stepType: TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE, isCompleted: true });
  }

  if (examType) {
    steps.push({ stepType: TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE, isCompleted: true });
    if (hasChallenge) {
      steps.push({ stepType: TestConfigStepType.SET_EXAM_TYPE, isCompleted: true });
    }
  }

  // TODO: Template exam types
  if (examTemplate) {
    steps.push({ stepType: TestConfigStepType.SET_EXAM_TEMPLATE, isCompleted: true });
  }

  if (numOfQuestions) {
    steps.push({ stepType: TestConfigStepType.SET_NUM_QUESTIONS, isCompleted: true });
  }

  if (contentIds && contentLabel) {
    steps.push({ stepType: TestConfigStepType.SET_CONTENTS, isCompleted: true });
  }

  if (steps.length) {
    return {
      steps: steps,
      currentStepIndex: steps.length - 1,
      isConfigCompleted: false,
    };
  }
  return {};
};
